export const replaceDotWithComma = (price: string | number): string => {
  if (!price) {
    return '';
  }
  return price.toString().replace(/[.]/, ',');
};

export const formatToTwoDecimalPlacesRoundingUp = (price: string | number): string => {
  return formatDecimalPlacesRoundingUp(price, 2);
};

export const formatDecimalPlacesRoundingUp = (price: string | number, places: number) => {
  if (typeof price !== 'number' && !price) {
    return '';
  }
  if (typeof price === 'string') {
    price = Number.parseFloat(price);
  }
  price = Math.ceil(price * Math.pow(10, places)) / Math.pow(10, places);
  return replaceDotWithComma(price.toFixed(places));
};

export const formatRoamingServicePrice = (price: string | number): string => {
  if (typeof price !== 'number' && !price) {
    return '';
  }
  price = price.toString().length <= 4 ? Number(price).toFixed(2) : Number(price).toString();
  return price.includes('.') ? replaceDotWithComma(price) : price;
};
